var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('top-header',{attrs:{"title":_vm.$t('learningPortal')}}),_c('v-progress-linear',{attrs:{"indeterminate":"","active":_vm.loading}}),_c('v-container',[_c('v-row',[_c('v-col',{attrs:{"cols":"12","md":"6"}},[_c('invitation-code-card',{attrs:{"error":_vm.error},on:{"sign-in":_vm.signIn}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }